import axios from './_axios';
import entrypoints from './_entrypoints';
import { getData, reduceToSearchCriteria } from '../shared/functions';
/**
 * Fetches all the available widgets and then
 */
var getAvailableSearchCriteria = function () { return (axios.get(entrypoints.widget)
    .then(getData)
    .then(reduceToSearchCriteria)); };
export default getAvailableSearchCriteria;
